module.exports = __webpack_public_path__ + "img/data_bg.85d78427.jpg";